/**
 * Converts a `colors` config object (global or a per-tile `custom` entry)
 * into a flat map of CSS custom properties.
 *
 * @param {Object} colors
 * @returns {Object} CSS custom property map, e.g. { '--wsp-free-fill': '#808080', ... }
 */
export function buildColorVars( colors ) {
	const style = {};

	const setVar = ( cssVar, value ) => {
		if ( value != null ) style[ cssVar ] = value;
	};

	setVar( '--wsp-pitch-bg', colors.bg     );
	setVar( '--wsp-fill',     colors.fill   );
	setVar( '--wsp-stroke',   colors.stroke );
	setVar( '--wsp-blend',    colors.blend  );

	for ( const state of [ 'free', 'selected', 'pending', 'occupied' ] ) {
		let s = colors[ state ];
		if ( ! s ) continue;
		if ( typeof s === 'string' ) s = { fill: s };
		setVar( `--wsp-${ state }-fill`,   s.fill   );
		setVar( `--wsp-${ state }-stroke`, s.stroke );
		setVar( `--wsp-${ state }-blend`,  s.blend  );
		let h = s.hover;
		if ( ! h ) continue;
		if ( typeof h === 'string' ) h = { fill: h };
		setVar( `--wsp-${ state }-hover-fill`,   h.fill   );
		setVar( `--wsp-${ state }-hover-stroke`, h.stroke );
		setVar( `--wsp-${ state }-hover-blend`,  h.blend  );
	}

	return style;
}
